import React from 'react';
import StarOutlineIcon from './star-outline';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ShortlistIcon(props) {
  return ___EmotionJSX(StarOutlineIcon, props);
}